import { render, staticRenderFns } from "./StatusGift.vue?vue&type=template&id=118ef050&"
import script from "./StatusGift.vue?vue&type=script&lang=js&"
export * from "./StatusGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports